import { useApiDefaults } from "hooks/useApiDefaults";
import axios from 'config/axios';
import { useQuery } from '@tanstack/react-query';
import { ReactQueryKeys } from 'config/constant';
import { useDispatch } from 'react-redux';
import {
  fetchCateringDepartmentTree,
  fetchCateringDepartmentTreeSuccess,
  fetchCateringDepartmentTreeFailure,
} from 'redux/actions/cateringAndMeal';
import { refetchOnWindowFocus } from 'config/reactQuery';

export const useGetCateringTree = () => {
  const apiDefaults = useApiDefaults();
  const dispatch = useDispatch();

  const fetchCateringTree = async () => {
    dispatch(fetchCateringDepartmentTree());
    try {
      const response = await axios.post('/AogGetCateringAndMealkitTreeView', apiDefaults);
      const data = response?.data?.data;
      dispatch(fetchCateringDepartmentTreeSuccess(data));
      return data;
    } catch (error) {
      dispatch(fetchCateringDepartmentTreeFailure({ error: error?.data?.message || error.message }));
      throw error;
    }
  };

  const { data = [], isLoading, error } = useQuery({
    queryKey: [ReactQueryKeys.CATERING_TREE, apiDefaults],
    queryFn: fetchCateringTree,
    refetchOnWindowFocus,
  });

  return {
    data,
    isLoading,
    error,
  };
};